import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { TextField, Autocomplete, Grid } from "@mui/material";
import { Search } from "@mui/icons-material";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./commonBtn.css";
import axios from "axios";
import { baseUrl } from "config";

import { redirectUrl } from "config";
import DynamicTable from "./components/DynamicTable";
import MultiPrint from "./components/MultiPrint";
import Header from "layout/MainLayout/Header";
import { minWidth } from "@mui/system";

function EmployeeItemWiseReport() {
  /////api
  const EmployeeItemWiseReportApi = "/getSalesmanReport";
  const EmployeeItemWiseMasterApi = "/getSalesmanMasters";

  const moduleMenuItems = [
    { id: "1", label: "ALL" },
    { id: "2", label: "B2B" },
    { id: "3", label: "B2C" },
  ];

  const viewTypeOptions = [
    { id: "1", label: "DETAIL" },
    { id: "2", label: "SUMMARY" },
  ];

  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [tabledata, setTableData] = useState([]);
  const [EmployeeDetails, setEmployeeDetails] = useState({
    id: "",
    label: "ALL",
  });
  const [Employees, setEmployees] = useState([]);
  const [item, setItem] = useState({ id: "", label: "ALL" });
  const [items, setItems] = useState([]);
  const [billType, setBillType] = useState("ALL");
  const [viewType, setViewType] = useState("DETAIL");

  const getSalesReportData = () => {
    axios
      .post(
        `${baseUrl}${EmployeeItemWiseReportApi}`,
        {
          FromDate: fromDate,
          ToDate: toDate,
          item: item,
          customer: EmployeeDetails,
          billType,
          viewType,
        },
        { withCredentials: true }
      )
      .then((res) => {
        if (viewType === "SUMMARY") {
          // Summary: flat array, group by SalesBill_GoodsOn (employee)
          // Map Tqty -> Qty and NetTotal -> Total for DynamicTable footer
          const mapped = res.data.map((row) => ({
            ...row,
            Qty: parseFloat(row.Tqty) || 0,
            Total: parseFloat(row.NetTotal) || 0,
          }));
          const grouped = Object.groupBy(
            mapped,
            (row) => row.SalesBill_GoodsOn || "N/A"
          );
          setTableData(Object.entries(grouped));
        } else {
          // Detail: group by GoodsOn as before
          setTableData(
            Object.entries(Object.groupBy(res.data, (idx) => idx.GoodsOn))
          );
        }
      })
      .catch((err) => {
        if (
          (err.response && err.response.status === 403) ||
          err.response.status === 401
        ) {
          redirectUrl();
        } else {
          console.error("Error fetching sales report data:", err);
        }
      });
  };
  const getSalesMasterData = () => {
    axios
      .get(`${baseUrl}${EmployeeItemWiseMasterApi}`, { withCredentials: true })
      .then((res) => {
        setEmployees(res.data?.employees || []);
        setItems(res.data?.salesItems || []);
      })
      .catch((err) => {
        if (
          (err.response && err.response.status === 403) ||
          err.response.status === 401
        ) {
          redirectUrl();
        } else {
          console.error("Error fetching sales report data:", err);
        }
      });
  };

  useEffect(() => {
    // getSalesReportData();
    getSalesMasterData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const detailColumns = [
    {
      field: "id",
      headerName: "SI No.",
      headerClassName: "custom-header-class",
      width: 90,
      align: "center",
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "ItemC",
      headerName: "Product Code",
      headerClassName: "custom-header-class",
      width: 90,
      flex: 1,
    },
    {
      field: "Item",
      headerName: "Product Name",
      headerClassName: "custom-header-class",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "Unit",
      headerName: "Unit",
      headerClassName: "custom-header-class",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "Qty",
      headerName: "Qty",
      headerClassName: "custom-header-class",
      minWidth: 200,
      flex: 1,
    },
    {
      field : "Rate",
      Header: "Rate",
      headerClassName: "custom-header-class",
      minWidth:200,
      flex:1, 
    },
    {
      field: "NetV",
      headerName: "Net Amount",
      headerClassName: "custom-header-class",
      minWidth: 200,
      flex: 1,
    },
  ];

  const summaryColumns = [
    {
      field: "item",
      headerName: "Item Name",
      headerClassName: "custom-header-class",
      minWidth: 250,
      flex: 2,
    },
    {
      field: "Tqty",
      headerName: "Total Qty",
      headerClassName: "custom-header-class",
      minWidth: 120,
      flex: 1,
      renderCell: (params) =>
        parseFloat(params.value || 0).toFixed(2),
    },
    {
      field: "SalesBill_Rate",
      headerName: "Rate",
      headerClassName: "custom-header-class",
      minWidth: 120,
      flex: 1,
      renderCell: (params) =>
        parseFloat(params.value || 0).toFixed(2),
    },
    {
      field: "NetTotal",
      headerName: "Net Total",
      headerClassName: "custom-header-class",
      minWidth: 150,
      flex: 1,
      renderCell: (params) =>
        parseFloat(params.value || 0).toFixed(2),
    },
  ];

  const columns = viewType === "SUMMARY" ? summaryColumns : detailColumns;

  const onSearch = () => {
    getSalesReportData();
  };

  const handlebillTypeChange = (e) => {
    const { value } = e.target;
    setBillType(value);
  };

  const handleViewTypeChange = (e) => {
    const { value } = e.target;
    setViewType(value);
    setTableData([]);
  };

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          background: "white",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{ textField: { size: "small", fullWidth: true } }}
                label="From"
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                format="DD MMMM YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{ textField: { size: "small", fullWidth: true } }}
                label="To"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                format="DD MMMM YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <Autocomplete
              disableClearable
              disablePortal
              id="combo-box-demo"
              options={Employees}
              value={EmployeeDetails}
              getOptionLabel={(option) => option.label}
              onChange={(e, v) => {
                setEmployeeDetails(v);
              }}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  {...params}
                  label="Select Employee"
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <Autocomplete
              disableClearable
              disablePortal
              id="combo-box-demo"
              options={items}
              value={item}
              onChange={(e, v) => {
                setItem(v);
              }}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  {...params}
                  label="Select Item"
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={1.5} lg={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Bill Type</InputLabel>
              <Select
                name="billType"
                value={billType}
                label="Bill Type"
                onChange={handlebillTypeChange}
              >
                {moduleMenuItems?.map((item) => (
                  <MenuItem key={item.id} value={item?.label}>{item?.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={1.5} lg={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>View Type</InputLabel>
              <Select
                name="viewType"
                value={viewType}
                label="View Type"
                onChange={handleViewTypeChange}
              >
                {viewTypeOptions?.map((opt) => (
                  <MenuItem key={opt.id} value={opt?.label}>{opt?.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid container spacing={15} alignItems="center" padding={1}>
            <Grid item xs={12} sm={2} md={2} lg={1} ml={2} >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Search />}
                onClick={onSearch}
              >
                Submit
              </Button>
            </Grid>

            <Grid item xs={12} sm={2} md={1} lg={1} >
              <MultiPrint
                rows={Object.fromEntries(tabledata)}
                columns={columns}
                data={{ EmployeeDetails, item }}
                EmployeeDetails={EmployeeDetails}
              />
            </Grid>
          </Grid>
        </Grid>

        {tabledata.map(([name, itx]) => {
          const mapped = [...itx].map((row, idx) => ({
            ...row,
            id: row.id || `summary_${idx}`,
          }));
          return (
            <Box sx={{ p: 1 }} key={name}>
              <div style={{ color: "black", fontWeight: 700, fontSize: 20 }}>
                {name}
              </div>
              {itx.length > 0 && (
                <DynamicTable row={mapped} columns={columns} />
              )}
            </Box>
          );
        })}
      </Box>
    </div>
  );
}

export default EmployeeItemWiseReport;
